// ─── ЧАЙНАЯ СДВИГАЕТ СЕТКУ (04.10.2026, владелец) ─────────────────────────────
// Психушка 03.10: игра 19:00 с чайной (филиал psih: shifting=1, отсечка 19:00,
// tea_before=1, tea_after=0) не сдвинула следующие слоты, и ДК закрыл 20:30 руками
// блоком «Чайная». Сетка филиала со сдвигом уже нарезана с чайной там, где она
// положена по умолчанию (шаг = игра + уборка + 45 до отсечки, игра + уборка после).
// Раньше был только обратный случай и только в сетке ДК: чайная положена, но не взята,
// и свободные слоты уходят на 45 минут раньше. Владелец (04.10): чайная, ВЗЯТАЯ там, где
// её по умолчанию нет, занимает квест ещё на 45 минут после игры и уборки. Следующие
// свободные слоты уезжают вперёд цепочкой (20:30 → 21:15, 22:00 → 22:45 …), и это видят
// все контуры, как у mc_shift: сетка ДК, гейт, публичные слоты (виджет/TMA) и расписание
// «Мира Квестов». Здесь общая арифметика. Файл без импортов, как mcSpan.ts: его тест
// исполняется node'ом напрямую.

/** Длительность чайной, минуты. Та же константа режет сетку (генератор слотов, сетка ДК, модалка). */
export const TEA_MIN_DEFAULT = 45;

/** Правило чайной филиала (branches.shifting / tea_cutoff / tea_before / tea_after). */
export interface TeaRule {
  /** «Тип сетки: Со сдвигом». Без него чайная сетку не двигает ни в одну сторону. */
  shifting: boolean;
  /** Отсечка "HH:MM": игры, начатые раньше неё, живут по tea_before, остальные по tea_after. */
  cutoff: string;
  before: boolean;
  after: boolean;
}

const toMin = (s: string): number => {
  const [h, m] = String(s).split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
};
/** D1 отдаёт флаги как 1/0, сетка как boolean. */
const flag = (v: unknown): boolean => v === true || Number(v) === 1;

/** Правило из строки branches (snake_case, как её читает API). Нет строки — сдвиг выключен. */
export function teaRuleOf(row: { shifting?: unknown; tea_cutoff?: unknown; tea_before?: unknown; tea_after?: unknown } | null | undefined): TeaRule {
  const cutoff = typeof row?.tea_cutoff === "string" && row.tea_cutoff ? row.tea_cutoff : "19:00";
  return { shifting: flag(row?.shifting), cutoff, before: flag(row?.tea_before), after: flag(row?.tea_after) };
}

/**
 * Положена ли чайная по умолчанию игре, начатой в `time`. Правило сетки ДК и модалки брони
 * без изменений: ночной слот (раньше 06:00, канон dates.NIGHT_SLOT_END) смотрит на tea_after;
 * начало раньше отсечки — tea_before; иначе tea_after. '19:00' при отсечке '19:00' — уже «после».
 */
export function expectTea(rule: Pick<TeaRule, "cutoff" | "before" | "after">, time: string): boolean {
  const t = toMin(time);
  if (t < 6 * 60) return rule.after;
  return t < toMin(rule.cutoff) ? rule.before : rule.after;
}

/**
 * Лишние минуты чайной у игры, начатой в `start`: филиал со сдвигом, чайная взята, а по
 * умолчанию не положена → TEA_MIN_DEFAULT, иначе 0. Эти минуты прибавляются к игре с уборкой:
 * 19:00 + 75 + 15 + 45 → квест свободен в 21:15.
 */
export function teaExtraMinutes(rule: TeaRule, start: string, tea: unknown): number {
  return rule.shifting && flag(tea) && !expectTea(rule, start) ? TEA_MIN_DEFAULT : 0;
}

/**
 * Занят ли слот хвостом лишней чайной. Время в абсолютных минутах на одной шкале (вчерашняя
 * игра 23:30 = −30, сегодняшний ночной слот 01:00 = 60). Слот занят, если начинается после
 * игры, но раньше, чем квест освободится: start + игра + уборка + чайная.
 */
export function takenByTea(slotAt: number, start: number, span: number, extra: number): boolean {
  return extra > 0 && slotAt > start && slotAt < start + span + extra;
}
